/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {Serial} from "../../Serial";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ScatterSymbol} from "../../symbol/ScatterSymbol";
import {SerialSound} from "../../sound/SerialSound";

export class ScatterLandingController extends ReelStopPresentationController {

    public get scatterCounter():number {
        return this._scatters.filter(s => s != null).length;
    }

    private _scatters:ScatterSymbol[];

    constructor() {
        super("ScatterLandingController");
        this._scatters = [];
        let scatterCounter = 0;
        Serial.model.parsedInitData.scatterPositions.forEach((position, reelId) => {
            if(reelId > 0 && reelId < 4 && position > -1) {
                this._scatters[reelId] = <ScatterSymbol>Serial.getSymbol(reelId, position);
                scatterCounter++;
            }
        });
        if(scatterCounter > 1) {
            this._scatters.forEach(s => {
                if(s != null) {
                    s.playWinAttention(scatterCounter === 3, true, false);
                }
            });
        }
    }

    protected async onReelBounce(data:IReelStateEventData):Promise<any> {
        const scatterPosition = Serial.model.parsedGameData.scatterPositions![data.reelId];
        if(data.reelId > 0 && data.reelId < 4) {
            if(scatterPosition === -1 || this._scatters[data.reelId] != null) {
                return Promise.resolve();
            }
            await this.playS1Attention(data.reelId, scatterPosition);
        }
        return Promise.resolve();
    }

    private playS1Attention(reelId:number, symId:number):Promise<any> {
        const symbol = <ScatterSymbol>Serial.getSymbol(reelId, symId);
        this._scatters[reelId] = symbol;

        const promises:Promise<any>[] = [];
        const scatters = this._scatters.filter(s => s != null);
        if(scatters.length === 3) {
            scatters.forEach(s => {
                promises.push(s.playWinAttention(true, false, s === symbol));
            });
            SerialSound.soundPlayer.playTrack({name : SerialSound.SCATTERS[2]});
            return Promise.all(promises);
        }
        if(scatters.length === 2) {
            scatters.forEach(s => {
                promises.push(s.playWinAttention(false, false, s === symbol));
            });
            SerialSound.soundPlayer.playTrack({name : SerialSound.SCATTERS[1]});
            return Promise.all(promises);
        }
        if(scatters.length === 1) {
            if(Serial.xBetController.selected) {
                symbol.blockReelLandingSound = false;
            } else {
                SerialSound.soundPlayer.playTrack({name : SerialSound.SCATTERS[0]});
            }
        }
        return Promise.resolve();
    }

    protected reset() {
        super.reset();
        if(!Serial.model.parsedGameData.mode.includes(GameMode.RESPIN)) {
            this._scatters = [];
        }
    }

    public async start():Promise<void> {
        await super.start();

        // TODO: this should move to last reel stop.
        if(Serial.model.parsedGameData.scatterToxWaysTriggered) {
            this._scatters.forEach(s => {
                if(s) {
                    s.stopWinLoop();
                }
            });
        }
    }
}